import React from 'react';
import Image from 'next/image';

const StudioLogo: React.FC = () => (
  <Image
    src="/assets/studio-logo-with-name-black.svg"
    alt="Studio Logo"
    width={70}
    height={70}
    className="w-auto h-7"
  />
);

export default StudioLogo;
